import React from "react";
import { Grid, Paper, Typography } from "@material-ui/core";
import withIntl from "../../../../utils/withIntl";
import ViewOrderItem from "../../ViewOrderItem";
import GetCurrency from "../../../../helper/GetCurrency";

const order = [
  { count: 3, name: "Coffee", unitPrice: 3.35, articlegroupName: "Drinks", articleFirstInArticlegroup: true },
  { count: 1, name: "Tea", unitPrice: 2.55, articlegroupName: "Drinks", articleFirstInArticlegroup: false },
  { count: 2, name: "Hamburger", unitPrice: 8.4, articlegroupName: "Food", articleFirstInArticlegroup: true },
  { count: 1, name: "Fries", unitPrice: 4.4, articlegroupName: "Food", articleFirstInArticlegroup: false },
];

function PrintInhouseBillView(props) {
  const layoutOptions = props.layoutOptions;

  const margin = (numberOfLines) => {
    let lines = [];

    for (let i = 0; i < numberOfLines; i++) {
      lines.push(<br />);
    }
    return lines;
  };

  return (
    <div>
      <Typography>{props.intl.formatMessage({ id: "example" })}</Typography>
      <Paper style={{ width: 380, border: "1px solid grey", display: "flex", justifyContent: "center" }}>
        <Grid container style={{ width: 340 }}>
          {layoutOptions.header && (
            <Grid item xs={12}>
              <Typography style={{ whiteSpace: "break-spaces", textAlign: "center" }}>
                {layoutOptions.header}
              </Typography>
            </Grid>
          )}
          <Grid item xs={12} style={{ textAlign: "center" }}>
            <Typography>{props.intl.formatMessage({ id: "bill" })}</Typography>
          </Grid>
          <Grid item xs={12} style={{ textAlign: "center" }}>
            <Typography>2021-01-07 14:24</Typography>
          </Grid>
          <Grid item xs={12} style={{ textAlign: "center" }}>
            <Typography>{props.intl.formatMessage({ id: "TABLE" })} 3</Typography>
          </Grid>
          <Grid item xs={12}>
            <hr />
          </Grid>
          {order.map((orderItem) => {
            return (
              <>
                <ViewOrderItem orderItem={orderItem} />
              </>
            );
          })}

          <Grid item xs={6}>
            <Typography>Total</Typography>
          </Grid>
          <Grid item xs={6} container justify={"flex-end"}>
            <Typography>
              {GetCurrency()}{" "}
              {order
                .reduce((subtotal, orderItem) => {
                  return subtotal + orderItem.unitPrice * orderItem.count;
                }, 0)
                .toFixed(2)}
            </Typography>
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
}

export default withIntl(PrintInhouseBillView);
